// extracted by mini-css-extract-plugin
export var legendIndicator = "_bo-1";
export var legendRight = "_bo-0";